import React from "react";
import {
  alpha,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { ArrowDown2 } from "../../../../components/Icon";
import { SubItem } from "./SubItem";
import { isChildActive } from "./utils";

/** Recursive elements to render menu group */
export const NestedGroup = ({
  child,
  level,
  open,
  expandedGroups,
  toggleGroup,
  navigate,
  location,
  theme,
}) => {
  // Open/close submenú
  const isOpen = expandedGroups[`level${level}`] === child.segment;
  // Calculate color intensity for alpha
  const opacity = Math.min(0.6 + level * 0.2, 1);
  // Determine if one of your children is selected
  const hasActiveChild = isChildActive(child, location);

  return (
    <>
      <ListItemButton
        onClick={() => toggleGroup(child.segment, level)}
        sx={{
          height: 35,
          mx: 0.4,
          px: 1.2,
          py: 0,
          mt: 0.25,
          borderRadius: isOpen ? "8px 8px 0 0" : 2,
          bgcolor: isOpen
            ? alpha(theme.palette.paleBlue2.main, opacity)
            : undefined,
        }}
      >
        <ListItemText
          primary={hasActiveChild ? `● ${child.title}` : child.title}
          primaryTypographyProps={{
            fontWeight: 600,
            fontSize: 12,
            color: hasActiveChild
              ? theme.palette.primary.main
              : theme.palette.secondary.dark,
          }}
        />
        <ArrowDown2
          style={{
            transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)",
            marginLeft: 1,
          }}
          color={
            hasActiveChild
              ? theme.palette.primary.main
              : theme.palette.secondary.main
          }
          size={14}
        />
      </ListItemButton>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          disablePadding
          sx={{
            bgcolor: alpha(theme.palette.paleBlue2.main, opacity),
            mx: 0.4,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          {child.children.map((subChild, idx) =>
            subChild.kind === "group" ? (
              <NestedGroup
                key={`${idx}-${subChild.title}`}
                child={subChild}
                level={level + 1}
                open={open}
                expandedGroups={expandedGroups}
                toggleGroup={toggleGroup}
                navigate={navigate}
                location={location}
                theme={theme}
              />
            ) : (
              <SubItem
                key={`${idx}-${subChild.segment}`}
                child={subChild}
                open={open}
                level={level + 1}
                navigate={navigate}
                location={location}
                theme={theme}
              />
            )
          )}
        </List>
      </Collapse>
    </>
  );
};
